import { jsxs as p, jsx as o } from "react/jsx-runtime";
import { forwardRef as d } from "react";
import { TooltipTrigger as s, Tooltip as a } from "./index.js";
function u(t) {
  return d(function(i, r) {
    const { tooltip: e, ...l } = i, n = !e?.children || e.isDisabled;
    return /* @__PURE__ */ p(
      s,
      {
        delay: e?.delay,
        isDisabled: n,
        isOpen: e?.isOpen,
        defaultOpen: e?.defaultOpen,
        onOpenChange: e?.onOpenChange,
        children: [
          /* @__PURE__ */ o(t, { ...l, ref: r }),
          !n && /* @__PURE__ */ o(a, { __inverted: e.__inverted, placement: e.placement, children: e.children })
        ]
      }
    );
  });
}
export {
  u as withTooltip
};
//# sourceMappingURL=withTooltip.js.map
